<template>
  <el-dialog :visible="show" @close="closeModal">
    <ModalHeader slot="title" icon="fas fa-question-circle" title="Xóa nhóm" />
    <div v-if="group">
      Bạn chắc chắn muốn xóa nhóm
      <b>{{ group.name }}</b> ?
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeModal">Trở về</el-button>
      <CommonButton type="danger" @click="deleteGroup">Xóa</CommonButton>
    </span>
  </el-dialog>
</template>

<script>
import { apiDeleteGroup } from '@/services/document_management_service'
import CommonButton from '@/components/common/CommonButton.vue'
import ModalHeader from '@/components/common/ModalHeader.vue'

export default {
  name: 'GroupDeleteModal',
  components: { ModalHeader, CommonButton },
  data() {
    return {
      show: false,
      group: null,
      refs: {
        CONFIRM_BUTTON: 'CONFIRM_BUTTON',
      },
    }
  },
  props: ['info'],
  methods: {
    openModal(group) {
      this.group = group
      this.show = true
    },
    closeModal() {
      this.show = false
    },
    async deleteGroup() {
      this.$refs[this.refs.CONFIRM_BUTTON].setLoading(true)
      let res = await apiDeleteGroup(this.group.id)
      if (res != null && res.status === 'SUCCESS') {
        this.$message.success(res.description)
        this.$data.show = false
        this.$emit('success')
      } else {
        this.$message.error('Có lỗi xảy ra')
      }
      this.$refs[this.refs.CONFIRM_BUTTON].setLoading(false)
    },
  },
}
</script>
